import React from "react";
import { useParams } from "react-router-dom";

import { Pagination } from "@graffer-inc/console-design-kit";

import { KintoneExportSettingsListController } from "../../../../organisms/kintone-export/kintone-export-settings-list-controller";
import { KintoneExportSettingsListTable } from "../../../../organisms/kintone-export/kintone-export-settings-list-table";
import { ServiceProviderTemplate } from "../../../../template/service-provider/default-template";
import { useKintoneExportSettings } from "../../../data-transfer/kintone-export/page-hooks/kintone-export-settings/hook";
import { ServiceProviderR } from "../../routes";
import { KintoneExportOrgProductAssertion } from "./plugin/kintone-export-org-product-assertion-plugin";

export const KintoneExportSettingsPage: React.FC = () => {
  const { tenantId } = useParams<{ tenantId: string }>();
  const {
    kintoneExportSettings,
    page,
    setPage,
    lastPage,
    handleKintoneExportSettingRowClick,
    handleCreateKintoneExportSetting,
  } = useKintoneExportSettings({
    tenantId,
    detailLinkProvider: ServiceProviderR.KintoneExportSettingDetail.link,
    createLinkProvider: ServiceProviderR.KintoneExportSettingCreate.link,
  });

  return (
    <>
      <KintoneExportOrgProductAssertion />
      <ServiceProviderTemplate
        breadcrumbs={[
          {
            to: ServiceProviderR.Home.link({}),
            title: "Home",
          },
          {
            to: ServiceProviderR.DataTransferTop.link({ tenantId }),
            title: "データ連携",
          },
          {
            to: ServiceProviderR.KintoneExportSettings.link({ tenantId }),
            title: "スマート申請の申請データを kintone へ転送",
          },
        ]}
      >
        <KintoneExportSettingsListController
          onClickCreate={handleCreateKintoneExportSetting}
        />
        <KintoneExportSettingsListTable
          kintoneExportSettings={kintoneExportSettings}
          onRowClick={handleKintoneExportSettingRowClick}
        />
        <Pagination
          onPageClick={setPage}
          currentPage={page}
          lastPage={lastPage}
        />
      </ServiceProviderTemplate>
    </>
  );
};
